import React, { useContext, useEffect, useState } from "react";
import AppMenuitem from "./AppMenuitem";
import { LayoutContext } from "./context/layoutcontext";
import { MenuProvider } from "./context/menucontext";
import { useSession } from "next-auth/react";
import { useRouter } from "next/router";
import Link from "next/link";
import { decrypt, decrypter } from "../utilities/encrypt";
import { RoleContext } from "./context/rolecontext";
import { listingMenu } from "../utilities/generaltool";

const AppMenu = () => {
  const router = useRouter();
  const { layoutConfig } = useContext(LayoutContext);
  const { data: session, status } = useSession();
  const [models, setModels] = useState([]);
  // const model = [
  //     {
  //         label: 'Home',
  //         items: [{ label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/' }]
  //     },
  //     {
  //         label: 'UI Components',
  //         items: [
  //             { label: 'Form Layout', icon: 'pi pi-fw pi-id-card', to: '/uikit/formlayout' },
  //             { label: 'Input', icon: 'pi pi-fw pi-check-square', to: '/uikit/input' },
  //             { label: 'Float Label', icon: 'pi pi-fw pi-bookmark', to: '/uikit/floatlabel' },
  //             { label: 'Invalid State', icon: 'pi pi-fw pi-exclamation-circle', to: '/uikit/invalidstate' },
  //             { label: 'Button', icon: 'pi pi-fw pi-mobile', to: '/uikit/button', class: 'rotated-icon' },
  //             { label: 'Table', icon: 'pi pi-fw pi-table', to: '/uikit/table' },
  //             { label: 'List', icon: 'pi pi-fw pi-list', to: '/uikit/list' },
  //             { label: 'Tree', icon: 'pi pi-fw pi-share-alt', to: '/uikit/tree' },
  //             { label: 'Panel', icon: 'pi pi-fw pi-tablet', to: '/uikit/panel' },
  //             { label: 'Overlay', icon: 'pi pi-fw pi-clone', to: '/uikit/overlay' },
  //             { label: 'Media', icon: 'pi pi-fw pi-image', to: '/uikit/media' },
  //             { label: 'Menu', icon: 'pi pi-fw pi-bars', to: '/uikit/menu', preventExact: true },
  //             { label: 'Message', icon: 'pi pi-fw pi-comment', to: '/uikit/message' },
  //             { label: 'File', icon: 'pi pi-fw pi-file', to: '/uikit/file' },
  //             { label: 'Chart', icon: 'pi pi-fw pi-chart-bar', to: '/uikit/charts' },
  //             { label: 'Misc', icon: 'pi pi-fw pi-circle', to: '/uikit/misc' }
  //         ]
  //     },
  //     {
  //         label: 'Prime Blocks',
  //         items: [
  //             { label: 'Free Blocks', icon: 'pi pi-fw pi-eye', to: '/blocks', badge: 'NEW' },
  //             { label: 'All Blocks', icon: 'pi pi-fw pi-globe', url: 'https://blocks.primereact.org', target: '_blank' }
  //         ]
  //     },
  //     {
  //         label: 'Utilities',
  //         items: [
  //             { label: 'PrimeIcons', icon: 'pi pi-fw pi-prime', to: '/utilities/icons' },
  //             { label: 'PrimeFlex', icon: 'pi pi-fw pi-desktop', url: 'https://www.primefaces.org/primeflex/', target: '_blank' }
  //         ]
  //     },
  //     {
  //         label: 'Pages',
  //         icon: 'pi pi-fw pi-briefcase',
  //         to: '/pages',
  //         items: [
  //             {
  //                 label: 'Landing',
  //                 icon: 'pi pi-fw pi-globe',
  //                 to: '/landing'
  //             },
  //             {
  //                 label: 'Auth',
  //                 icon: 'pi pi-fw pi-user',
  //                 items: [
  //                     {
  //                         label: 'Login',
  //                         icon: 'pi pi-fw pi-sign-in',
  //                         to: '/auth/login'
  //                     },
  //                     {
  //                         label: 'Error',
  //                         icon: 'pi pi-fw pi-times-circle',
  //                         to: '/auth/error'
  //                     },
  //                     {
  //                         label: 'Access Denied',
  //                         icon: 'pi pi-fw pi-lock',
  //                         to: '/auth/access'
  //                     }
  //                 ]
  //             },
  //             {
  //                 label: 'Crud',
  //                 icon: 'pi pi-fw pi-pencil',
  //                 to: '/pages/crud'
  //             },
  //             {
  //                 label: 'Timeline',
  //                 icon: 'pi pi-fw pi-calendar',
  //                 to: '/pages/timeline'
  //             },
  //             {
  //                 label: 'Not Found',
  //                 icon: 'pi pi-fw pi-exclamation-circle',
  //                 to: '/pages/notfound'
  //             },
  //             {
  //                 label: 'Empty',
  //                 icon: 'pi pi-fw pi-circle-off',
  //                 to: '/pages/empty'
  //             }
  //         ]
  //     },
  //     {
  //         label: 'Hierarchy',
  //         items: [
  //             {
  //                 label: 'Submenu 1',
  //                 icon: 'pi pi-fw pi-bookmark',
  //                 items: [
  //                     {
  //                         label: 'Submenu 1.1',
  //                         icon: 'pi pi-fw pi-bookmark',
  //                         items: [
  //                             { label: 'Submenu 1.1.1', icon: 'pi pi-fw pi-bookmark' },
  //                             { label: 'Submenu 1.1.2', icon: 'pi pi-fw pi-bookmark' },
  //                             { label: 'Submenu 1.1.3', icon: 'pi pi-fw pi-bookmark' }
  //                         ]
  //                     },
  //                     {
  //                         label: 'Submenu 1.2',
  //                         icon: 'pi pi-fw pi-bookmark',
  //                         items: [{ label: 'Submenu 1.2.1', icon: 'pi pi-fw pi-bookmark' }]
  //                     }
  //                 ]
  //             },
  //             {
  //                 label: 'Submenu 2',
  //                 icon: 'pi pi-fw pi-bookmark',
  //                 items: [
  //                     {
  //                         label: 'Submenu 2.1',
  //                         icon: 'pi pi-fw pi-bookmark',
  //                         items: [
  //                             { label: 'Submenu 2.1.1', icon: 'pi pi-fw pi-bookmark' },
  //                             { label: 'Submenu 2.1.2', icon: 'pi pi-fw pi-bookmark' }
  //                         ]
  //                     },
  //                     {
  //                         label: 'Submenu 2.2',
  //                         icon: 'pi pi-fw pi-bookmark',
  //                         items: [{ label: 'Submenu 2.2.1', icon: 'pi pi-fw pi-bookmark' }]
  //                     }
  //                 ]
  //             }
  //         ]
  //     },
  //     {
  //         label: 'Get Started',
  //         items: [
  //             {
  //                 label: 'Documentation',
  //                 icon: 'pi pi-fw pi-question',
  //                 to: '/documentation'
  //             },
  //             {
  //                 label: 'View Source',
  //                 icon: 'pi pi-fw pi-search',
  //                 url: 'https://github.com/primefaces/sakai-react',
  //                 target: '_blank'
  //             }
  //         ]
  //     }
  // ];
  let model = [];
  model = session?.user?.menu;
  let arr = [];
  if (status == "authenticated") {
    // console.log(models)
    // const role = session?.user.userRole;
    // if(!Array.isArray(role)){
    //     return
    // }
    // session?.user.userRole.map((val,i)=>{
    //     if(val == 'dashboard'){
    //         arr.push({
    //             label : 'Home',
    //             items : [{label:'Dashboard', to:'/'}]
    //         })
    //     }
    // });
    // // session?.user.menu.map((val)=>{
    // //      console.log(val);
    // // });
    // arr.push({
    //     label:'Product & Service',
    //     items:[]
    // });
    // role.forEach( val => {
    //     if (val === 'invoice') {
    //         arr[1].items.push({ label: 'Invoice', to: '/invoice' });
    //     } else if (val === 'product') {
    //         arr[1].items.push({ label: 'Product', to: '/product' });
    //     } else if (val === 'ticket') {
    //         arr[1].items.push({ label: 'Ticket',to: '/ticket' });
    //     }
    // });
    // if(role.indexOf('karyawan') !== -1){
    //     arr[1].items.push({label:'Karyawan',to:'/karyawan'})
    // }
    // if(role.indexOf('staff') !== -1){
    //     arr[1].items.push({label:'Staff Mars',to:'/staff'})
    // }
    // if(role.indexOf('setting-apps') !== -1){
    //     arr[1].items.push({label:'Setup Apps',to:'/setupapps'})
    // }
    // if(role.indexOf('roles') !== -1){
    //     arr[1].items.push({label:'Role',to:'/roles'});
    // }
  } else if (status == "unauthenticated") {
    router.push("/login");
  }

  return (
    <MenuProvider>
      <ul className="layout-menu">
        {model?.map((item, i) => {
          return !item.seperator ? (
            <AppMenuitem item={item} root={true} index={i} key={item.label} />
          ) : (
            <li className="menu-separator"></li>
          );
        })}
      </ul>
    </MenuProvider>
  );
};

export default AppMenu;
